import emptyImage from '@fukuri-admins/assets/images/circle-company.svg';
import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import styles from './emptyStyles.module.scss';

/**
 * 利用企業一覧 Empty 状態 Presentation
 *
 * 利用企業が 0 件のときに表示する
 */
export const ClientListEmptyPresentation: React.FC = () => (
  <Stack
    gap={24}
    alignItems='center'
    justifyContent='center'
    height='100%'
    className={styles.container}
  >
    <img src={emptyImage} alt='empty list image' />
    <p className={styles.message}>利用企業が登録されていません</p>
    <ButtonLink
      variant='primary'
      size='md'
      icon={<PlusIcon size='xs' />}
      iconPosition='left'
      to='/clients/new'
    >
      新規追加
    </ButtonLink>
  </Stack>
);
